import { JobActionTypes } from 'helpers/constants/action_types/job'

// TODO Check for unused actions
export const JobActions = {
  FETCH: (payload) => ({ payload, type: JobActionTypes.FETCH }),

  FETCH_FAILURE: () => ({ type: JobActionTypes.FETCH_FAILURE }),

  FETCH_SUCCESS: (payload) => ({ payload, type: JobActionTypes.FETCH_SUCCESS }),

  FETCH_BY_SECRET_ALIAS_ID: (payload) => ({ payload, type: JobActionTypes.FETCH_BY_SECRET_ALIAS_ID }),

  FETCH_BY_SECRET_ALIAS_ID_FAILURE: () => ({ type: JobActionTypes.FETCH_BY_SECRET_ALIAS_ID_FAILURE }),

  FETCH_BY_SECRET_ALIAS_ID_SUCCESS: (payload) => ({ payload, type: JobActionTypes.FETCH_BY_SECRET_ALIAS_ID_SUCCESS }),

  UPDATE: (id, payload, onSuccessCallback, onErrorCallback) => ({ payload, id, type: JobActionTypes.UPDATE, onSuccessCallback, onErrorCallback }),

  UPDATE_FAILURE: () => ({ type: JobActionTypes.UPDATE_FAILURE }),

  UPDATE_SUCCESS: (payload) => ({ payload, type: JobActionTypes.UPDATE_SUCCESS }),

  TOGGLE_TALENT_SELECTION: (id) => ({ id, type: JobActionTypes.TOGGLE_TALENT_SELECTION }),

  TOGGLE_TALENT_SELECTION_FAILURE: () => ({ type: JobActionTypes.TOGGLE_TALENT_SELECTION_FAILURE }),

  TOGGLE_TALENT_SELECTION_SUCCESS: (payload) => ({ payload, type: JobActionTypes.TOGGLE_TALENT_SELECTION_SUCCESS }),

  CANCEL: (job, onErrorCallback) => ({ job, onErrorCallback, type: JobActionTypes.CANCEL }),

  CANCEL_FAILURE: () => ({ type: JobActionTypes.CANCEL_FAILURE }),

  CANCEL_SUCCESS: (payload) => ({ payload, type: JobActionTypes.CANCEL_SUCCESS }),

  SELECT: (jobId, selectedApplicantId, paymentInfo, onSuccessCallback) => ({
    jobId,
    selectedApplicantId,
    paymentInfo,
    onSuccessCallback,
    type: JobActionTypes.SELECT,
  }),

  SELECT_FAILURE: () => ({ type: JobActionTypes.SELECT_FAILURE }),

  SELECT_SUCCESS: (payload) => ({ payload, type: JobActionTypes.SELECT_SUCCESS }),

  DESELECT: (jobId, applicantId, onSuccessCallback) => ({ jobId, applicantId, type: JobActionTypes.DESELECT, onSuccessCallback }),

  DESELECT_FAILURE: () => ({ type: JobActionTypes.DESELECT_FAILURE }),

  DESELECT_SUCCESS: (payload) => ({ payload, type: JobActionTypes.DESELECT_SUCCESS }),

  RETRY_PAYMENT: (jobId, paymentMethodId, onSuccessCallback, onErrorCallback) => ({
    jobId,
    paymentMethodId,
    onSuccessCallback,
    onErrorCallback,
    type: JobActionTypes.RETRY_PAYMENT,
  }),

  RETRY_PAYMENT_FAILURE: () => ({ type: JobActionTypes.RETRY_PAYMENT_FAILURE }),

  RETRY_PAYMENT_SUCCESS: (payload) => ({ payload, type: JobActionTypes.RETRY_PAYMENT_SUCCESS }),

  INCREMENT_APPLICATION_COUNTER: (status) => ({ status, type: JobActionTypes.INCREMENT_APPLICATION_COUNTER }),

  DECREMENT_APPLICATION_COUNTER: (status) => ({ status, type: JobActionTypes.DECREMENT_APPLICATION_COUNTER }),
}
